module.exports = __webpack_public_path__ + "media/images/front/centres/showroom_onda-3bd5dbbb00fe3da4a1481c5f3f9eb577.webp";